<template>
<div class="chapter">
<div class="inner_page">
<div class="cover">
<img alt="cover" src="images/9781627798242.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?1fd6f6cf